import { useParams } from "react-router-dom"

import { NAMES_ROUTES, PARAMS } from "@/const/routes.constants"
import { Form } from "@/organisms/Form"

import type { SubType } from "@/api/usePolicies.types"
import type { PolicyPageProps } from ".."

export const usePolicyPage = (props: PolicyPageProps) => {
  const { type } = props

  const params = useParams()
  const subType = params[PARAMS.SUB_TYPE] as SubType

  const keyPrefix = "governance.policies.form"
  const keyPrefixSection = `${keyPrefix}.section`

  const { Details } = Form.Section
  const detailsKey = `${keyPrefixSection}.details.${subType}`
  const asideItems = [
    { key: Details.sectionId, tKey: detailsKey },
    {
      key: Form.Section.Resources.sectionId,
      tKey: `${keyPrefixSection}.resources.title`
    },
    {
      key: Form.Section.Conditions.sectionId,
      tKey: "forms.sections.conditions"
    },
    { key: Form.Section.Actions.sectionId, tKey: "forms.sections.actions" }
  ]

  const { GOVERNANCE } = NAMES_ROUTES
  const rootLink = `/${GOVERNANCE.ROOT}`
  // Convert type to GOVERNANCE key (e.g., "ci-sca" -> "CI_SCA")
  const governanceKey = type
    .toUpperCase()
    .replace(/-/g, "_") as keyof typeof GOVERNANCE
  const listLink = `${rootLink}/${GOVERNANCE[governanceKey]}/${subType}`
  const headerItems = [
    { link: rootLink, tKey: "navigation.governance" },
    { link: listLink, tKey: `governance.policies.${type}.title` },
    {
      fieldName: "name_details",
      tKey: `governance.policies.form.breadcrumb.${subType}`
    }
  ]

  return { headerItems, asideItems, subType, listLink, keyPrefix }
}
